import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=bf32ddd2&scoped=true&"
import script from "./footer.vue?vue&type=script&lang=ts&"
export * from "./footer.vue?vue&type=script&lang=ts&"
import style0 from "./footer.vue?vue&type=style&index=0&id=bf32ddd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf32ddd2",
  null
  
)

export default component.exports